// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'list';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M2.25 3.938a1.688 1.688 0 1 0 0-3.376 1.688 1.688 0 0 0 0 3.375zm0 6.75a1.688 1.688 0 1 0 0-3.376 1.688 1.688 0 0 0 0 3.375zm0 6.75a1.687 1.687 0 1 0 0-3.375 1.687 1.687 0 0 0 0 3.374zM6.188 2.25h11.25M6.188 9h11.25m-11.25 6.75h11.25'
  />
);

export const viewBox = '0 0 18 18';
